import type { Place } from "./types";

export function isGooglePlace(place: Pick<Place, "id" | "source">): boolean {
  return place.source === "google" || place.id.startsWith("google:");
}

export function isLocationInput(query: string): boolean {
  return (
    /https:\/\/[^\s<>]+/i.test(query) ||
    /^(?:https?:\/\/|geo:|(?:maps\.app\.goo\.gl|goo\.gl\/maps|(?:www\.)?google\.[a-z.]+\/maps|(?:www\.)?openstreetmap\.org)(?:\/|\?))/i.test(
      query.trim(),
    ) ||
    /^[-+]?\d{1,3}(?:\.\d+)?\s*[,;]\s*[-+]?\d{1,3}(?:\.\d+)?$/.test(
      query.trim(),
    )
  );
}

export function normalizedLocationInput(query: string): string {
  const value = query.trim();
  return /^(?:maps\.app\.goo\.gl|goo\.gl\/maps|(?:www\.)?google\.[a-z.]+\/maps|(?:www\.)?openstreetmap\.org)(?:\/|\?)/i.test(
    value,
  )
    ? `https://${value}`
    : value;
}

export function placeSourceLabel(place: Place): string {
  if (place.source === "community") return "מקום שאושר ב־Desty";
  if (place.source === "google-public") return "Google Maps · חיפוש משלים";
  if (isGooglePlace(place)) return "Google Maps";
  if (place.source === "overture") return "Overture Maps";
  if (place.source === "shared") return "מיקום שהוזן";
  return "מפות Desty";
}
